import React from 'react';
import styled from 'styled-components';
import MapLocationSvg from '../assets/hotels/details/MapLocationIcon.svg';

const MapLocationIcon = styled(MapLocationSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.fill};
`;

export default MapLocationIcon;
